import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type IFlameSignalData } from '../services/getFlameSignaGraphDataServiceNew'

export interface IFlameSignalDataState {
  isLoading: boolean
  error: string | null
  flameSignalData: any | null
  httpStatus: number | undefined
}

const initialState: IFlameSignalDataState = {
  isLoading: false,
  error: null,
  flameSignalData: null,
  httpStatus: 0
}

const deviceStatusSummarySlice = createSlice({
  name: 'flameSignalData',
  initialState,
  reducers: {
    flameSignalDataLoadingActionNew: (state) => {
      return {
        isLoading: true,
        error: null,
        flameSignalData: null,
        httpStatus: 0
      }
    },
    flameSignalDataUpdateActionNew: (state, action: PayloadAction<{ data: IFlameSignalData, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        flameSignalData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    flameSignalDataErrorActionNew: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        flameSignalData: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  flameSignalDataLoadingActionNew,
  flameSignalDataUpdateActionNew,
  flameSignalDataErrorActionNew
} = deviceStatusSummarySlice.actions

export default deviceStatusSummarySlice.reducer
